import { DateValidationError } from '@mui/x-date-pickers/models/validation'

export function dateErrorToString(
  error: DateValidationError,
): string | undefined {
  switch (error) {
    case null:
      return

    case 'disablePast':
      return 'Must not be in the past'

    case 'disableFuture':
      return 'Must not be in the future'

    case 'shouldDisableDate':
      return 'Date not available'

    case 'minDate':
    case 'maxDate':
    case 'invalidDate':
    default:
      return 'Invalid Date'
  }
}
